import { inject, Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslocoService } from '@jsverse/transloco';

@Injectable({ providedIn: 'root' })
export class LocalizedPaginatorIntl extends MatPaginatorIntl {
  private transloco = inject(TranslocoService);

  constructor() {
    super();
    this.transloco.langChanges$.subscribe(() => {
      this.itemsPerPageLabel = this.transloco.translate('material.paginator.itemsPerPage');
      this.nextPageLabel = this.transloco.translate('material.paginator.nextPage');
      this.previousPageLabel = this.transloco.translate('material.paginator.previousPage');
      this.firstPageLabel = this.transloco.translate('material.paginator.firstPage');
      this.lastPageLabel = this.transloco.translate('material.paginator.lastPage');
      this.changes.next();
    });
  }

  override getRangeLabel = (page: number, pageSize: number, length: number) => {
    const ofLabel = this.transloco.translate('material.paginator.rangeOf');
    if (length === 0 || pageSize === 0) {
      return `0 ${ofLabel} ${length}`;
    }
    length = Math.max(length, 0);
    const startIndex = page * pageSize;
    const endIndex = startIndex < length
      ? Math.min(startIndex + pageSize, length)
      : startIndex + pageSize;
    return `${startIndex + 1} - ${endIndex} ${ofLabel} ${length}`;
  };
}
